import dayjs from 'dayjs';
import * as yup from 'yup';

export const TIME_OPTIONS = [
  {
    label: '10 minutes',
    value: '10',
  },
  {
    label: '20 minutes',
    value: '20',
  },
  {
    label: '30 minutes',
    value: '30',
  },
  {
    label: '40 minutes',
    value: '40',
  },
  {
    label: '50 minutes',
    value: '50',
  },
  {
    label: '1 hour',
    value: '60',
  },
  {
    label: '1 hour, 10 minutes',
    value: '70',
  },
  {
    label: '1 hour, 20 minutes',
    value: '80',
  },
  {
    label: '1 hour, 30 minutes',
    value: '90',
  },
  {
    label: '1 hour, 40 minutes',
    value: '100',
  },
  {
    label: '1 hour, 50 minutes',
    value: '110',
  },
  {
    label: '2 hours',
    value: '120',
  },
];

export const validationSchema = yup.object().shape({
  location: yup.string().required('Please enter a location'),
  time: yup.string().required('Please select a time'),
  arrivalDay: yup.string().when('mode', {
    is: (mode: string) => mode === 'drive' || mode === 'transit',
    then: (schema) => schema.required('An arrival day is required.'),
    otherwise: (schema) => schema.notRequired(),
  }),
  arrivalTime: yup.string().when('mode', {
    is: 'transit',
    then: (schema) => schema.required('An arrival time is required.'),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const arrivalDayOptions = [
  { label: 'Weekday', value: '1' },
  { label: 'Saturday', value: '6' },
  { label: 'Sunday', value: '0' },
];

interface TimeSlot {
  value: string;
  label: string;
}

const startHour = 8;
const endHour = 20;
const minutes = [0, 30];

export const arrivalTimeOptions: TimeSlot[] = Array.from(
  { length: endHour - startHour + 1 },
  (_, i) => startHour + i,
).flatMap((hour) => {
  return minutes
    .map((minute) => {
      if (hour === endHour && minute > 0) return null;

      const time = dayjs().hour(hour).minute(minute).second(0);
      return {
        value: time.format('HH:mm'),
        label: time.format('h:mm A'),
      };
    })
    .filter((slot): slot is TimeSlot => slot !== null); // Filter out the nulls
});
